enum RoleInfoComponentTabs {
    GeneralInformation,
    Permissions
}

export { RoleInfoComponentTabs };
